module.exports = __webpack_public_path__ + "img/20220219_072724.7dc1ea83.jpg";